import { useCoupons } from 'hooks/useFetchCoupons';
import { type PaeHeroSessionsModel, PAE_HERO_SESSIONS_STATE } from './types';

export const usePaeHeroSessionsModel = (): PaeHeroSessionsModel => {
  const { remainingSessions, remainingSessionsThisMonth, enterpriseSessions } = useCoupons();
  const unlimitedThisMonth = remainingSessionsThisMonth === Infinity;

  const hasAny = remainingSessions > 0 || enterpriseSessions > 0;
  const finiteCount = unlimitedThisMonth ? 0 : remainingSessions;

  if (!hasAny) {
    return { state: PAE_HERO_SESSIONS_STATE.none, multipleCount: 0 };
  }
  if (unlimitedThisMonth || enterpriseSessions > 0) {
    return { state: PAE_HERO_SESSIONS_STATE.unlimited, multipleCount: 0 };
  }
  if (finiteCount <= 0) {
    return { state: PAE_HERO_SESSIONS_STATE.unlimited, multipleCount: 0 };
  }
  if (finiteCount === 1) {
    return { state: PAE_HERO_SESSIONS_STATE.single, multipleCount: 1 };
  }

  return { state: PAE_HERO_SESSIONS_STATE.multiple, multipleCount: finiteCount };
};
